import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getQuoteState } from "@insite/client-framework/Store/Data/Quotes/QuotesSelector";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import searchFilterTerms from "@tKgpco/Handlers/Terms/SearchFilterTerms";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import React, { useEffect } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapDispatchToProps = {
    searchFilterTerms,
};

const mapStateToProps = (state: CustomApplicationState) => ({
    isLoading: state.KGPState.customTerms.isLoading,
    isLoadingOverlay: state.KGPState.customTerms.isLoadingOverlay,
    terms: state.KGPState.customTerms.quoteTerms,
    session: getSession(state),
    myAccountPageLink: getPageLinkByPageType(state, "MyAccountPage"),
    quoteState: getQuoteState(state, state.pages.rfqQuoteDetails.quoteId),
});
const includeField = ["Terms"];
const includeRole = ["Administrator"];
interface CustomTermsStyles {
    wrapper?: InjectableCss;
}

const styles: CustomTermsStyles = {
    wrapper: {},
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & HasHistory & ResolveThunks<typeof mapDispatchToProps>;

const TermsPage: React.FC<Props> = ({ id, session, isLoadingOverlay, myAccountPageLink, searchFilterTerms, history }) => {

    useEffect(() => {
        searchFilterTerms({ queryParams: { page: 1 } });
    }, [myAccountPageLink]);
    return (
        <LoadingOverlay loading={isLoadingOverlay}>
            <StyledWrapper {...styles.wrapper}>
                <Zone contentId={id} zoneName="TermsPageContainer" />
            </StyledWrapper>
        </LoadingOverlay>
    );
};

const TermsPageWidget: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(TermsPage)),
    definition: {
        group: "Basic",
    },
};

export default TermsPageWidget;
